
<div class="row topRow" *ngIf="trainerForm">
  <div class="col-sm-12">
    <add-trainer [employee]="selectedEmployee" [roles]="roles" (employeeAdded)="closeBottomSheet()"></add-trainer>
  </div>
</div>


